import * as React from "react";
import { Box, CircularProgress, useColorScheme } from "@mui/material";


export function ComponentLoader({ loading }: { loading: boolean }): React.JSX.Element {
  const { colorScheme = "light" } = useColorScheme();

	return (
		<Box
			sx={{
        display: loading ? "flex" : "none",
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				width: "100%",
				height: "100%",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: colorScheme === "dark" ? "rgba(18, 21, 23, 0.5)" : "rgba(255, 255, 255, 0.5)",
				zIndex: 1000,
			}}
		>
			<CircularProgress size={30} />
		</Box>
	);
}
